import React from 'react';

import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Container } from './styles';

export default function Spinner({ loading }) {
  return (
    <Container loading={loading.toString()}>
      <CircularProgress />
    </Container>
  );
}

Spinner.propTypes = {
  loading: PropTypes.bool.isRequired,
};
